"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var constants_exports = {};
__export(constants_exports, {
  EMPTY_LOADER_STRING: () => EMPTY_LOADER_STRING,
  SERVER_CONTEXT_POST_RENDER_STRING: () => SERVER_CONTEXT_POST_RENDER_STRING,
  makeLoaderRouteIdStub: () => makeLoaderRouteIdStub
});
module.exports = __toCommonJS(constants_exports);
var EMPTY_LOADER_STRING = `export function loader() {return "__vxrn__loader__"};`;
function makeLoaderRouteIdStub(routeId) {
  return `export function loader() {return ${JSON.stringify(routeId)}};`;
}
var SERVER_CONTEXT_POST_RENDER_STRING = `_one_post_render_data_`;
//# sourceMappingURL=constants.js.map
